import type { ReactNode } from "react";
import { SectionHeader } from "./SectionHeader";
import { FeatureChip } from "./FeatureChip";
import { cn } from "@/utils/cn";

interface Feature {
  id: string;
  name: string;
  period: number;
  period2?: number;
  icon: ReactNode | null;
  color: string;
}

interface FeaturesSectionProps {
  features: Feature[];
}

export function FeaturesSection({ features }: FeaturesSectionProps) {
  return (
    <div>
      <SectionHeader title="Features" gradient="amber-orange" />

      {features.length > 0 ? (
        <div
          className={cn(
            "grid gap-2",
            "grid-cols-2 sm:grid-cols-3 md:grid-cols-4"
          )}
        >
          {features.map((feature) => (
            <FeatureChip
              key={feature.id}
              name={feature.name}
              period={feature.period}
              period2={feature.period2}
              icon={feature.icon}
              color={feature.color}
            />
          ))}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground italic">
          No features selected
        </p>
      )}
    </div>
  );
}
